import { useContext, useDebugValue } from "react";
import GlobalContext from "../contexts/globalcontext";

const useAuth = () => {
    const { auth } = useContext(GlobalContext);
    useDebugValue(auth, (auth) =>
        auth?.username ? "Logged In" : "Logged Out"
    );
    return useContext(GlobalContext);
};

export default useAuth;
